import React from 'react';
import { motion } from 'framer-motion';

const EventInfo = ({ language }) => {
  const content = {
    fr: {
      date: '16 Mai 2026',
      time: 'à 19H',
      venue: 'au Cirque Royal de Bruxelles',
      ticketOffice: 'Billetterie',
      live: 'Concert 100% LIVE',
      website: 'RÉSERVER VOS BILLETS',
      websiteUrl: 'https://www.ticketmaster.be/event/289249177'
    },
    en: {
      date: 'May 16, 2026',
      time: 'at 7:00 PM',
      venue: 'at Cirque Royal of Brussels',
      ticketOffice: 'Ticket Office',
      live: '100% LIVE Concert',
      website: 'GET YOUR TICKETS',
      websiteUrl: 'https://www.ticketmaster.be/event/289249177'
    }
  };

  const text = content[language];

  return (
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="relative group"
      >
        {/* Glow effect around card */}
        <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-3xl blur-xl opacity-40 group-hover:opacity-70 transition duration-500"></div>
        
        <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* Image du Cirque Royal */}
          <div className="w-full h-64 md:h-80 overflow-hidden relative">
            <motion.img
              initial={{ scale: 1.2 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              src="/images/cirque-royal.jpg"
              alt="Cirque Royal de Bruxelles"
              className="w-full h-full object-cover"
            />
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
          </div>

          <div className="p-8 md:p-12">
            <div className="text-center space-y-8">
              {/* Date et Heure */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                viewport={{ once: true }}
                className="border-b-2 border-navy/20 pb-6"
              >
                <h2 className="text-4xl md:text-6xl font-black bg-gradient-to-r from-navy via-blue-700 to-purple-700 bg-clip-text text-transparent mb-3">
                  {text.date}
                </h2>
                <p className="text-2xl md:text-4xl text-navy/80 font-semibold">
                  {text.time}
                </p>
              </motion.div>

              {/* Lieu */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.5 }}
                viewport={{ once: true }}
                className="py-6 border-b-2 border-navy/20"
              >
                <p className="text-xl md:text-3xl text-navy font-bold">
                  {text.venue}
                </p>
              </motion.div>

              {/* Concert Live */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.4, duration: 0.5, type: "spring", stiffness: 200 }}
                viewport={{ once: true }}
                className="py-6 border-b-2 border-navy/20"
              >
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="inline-block relative"
                >
                  {/* Glow effect */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full blur opacity-50 animate-pulse-glow"></div>
                  <div className="relative bg-gradient-to-r from-navy via-blue-700 to-purple-700 text-white px-10 py-4 rounded-full text-xl md:text-3xl font-black shadow-xl">
                    {text.live}
                  </div>
                </motion.div>
              </motion.div>

              {/* Billetterie */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.5 }}
                viewport={{ once: true }}
                className="pt-6"
              >
                <p className="text-lg md:text-xl text-navy/70 mb-4 font-semibold uppercase tracking-wide">
                  {text.ticketOffice}
                </p>
                <motion.a 
                  href={text.websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                  className="inline-block relative group/btn"
                >
                  {/* Button glow */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-full blur opacity-70 group-hover/btn:opacity-100 transition duration-300"></div>
                  
                  <div className="relative bg-gradient-to-r from-navy via-blue-700 to-purple-700 text-white px-10 py-5 rounded-full text-xl md:text-3xl font-black shadow-2xl overflow-hidden">
                    <span className="relative z-10">🎫 {text.website}</span>
                    {/* Shine effect */}
                    <div className="absolute inset-0 -translate-x-full group-hover/btn:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
                  </div>
                </motion.a>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default EventInfo;
